import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BackofficeContainerComponent } from './backoffice-container/backoffice-container.component';
import { StepperComponent } from './stepper/stepper.component';
import { BackofficeComponent } from './backoffice/backoffice.component';
import { SharedModule } from '../shared/shared.module';
import { MatStepperModule } from '@angular/material/stepper';
import { MatSnackBarModule, MAT_SNACK_BAR_DEFAULT_OPTIONS } from '@angular/material/snack-bar';
import { MatButtonModule } from '@angular/material/button';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatRadioModule } from '@angular/material/radio';
import { TechnologyComponent } from './technology/technology.component';
import { TipoProjetoComponent } from './tipo-projeto/tipo-projeto.component'
import { STEPPER_GLOBAL_OPTIONS } from '@angular/cdk/stepper';
import { MatDialogModule } from '@angular/material/dialog';
import { TechDialogComponent } from './tech-dialog/tech-dialog.component';
import { RemoveDialogComponent } from './remove-dialog/remove-dialog.component';
import { EditNameDialogComponent } from './edit-name-dialog/edit-name-dialog.component';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { AddItemBackofficeDialogComponent } from './add-item-backoffice-dialog/add-item-backoffice-dialog.component'
import { MatOptionModule } from '@angular/material/core';
import { MatSelectModule } from '@angular/material/select';
import { DocumentationComponent } from './documentation/documentation.component';
import { ConfigurationComponent } from './configuration/configuration.component';
import { MacroactivityComponent } from './macroactivity/macroactivity.component';
import { CatalogComponent } from './catalog/catalog.component';
import { MatTooltipModule } from '@angular/material/tooltip';
import { ProjectRiskComponent } from './project-risk/project-risk.component';
import { UsersComponent } from './users/users.component';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';
import { SubTasksComponent } from './sub-tasks/sub-tasks.component';
import { UserDialogComponent } from './user-dialog/user-dialog.component';
import { AddTipoProjetoDialogComponent } from './add-tipo-projeto-dialog/add-tipo-projeto-dialog.component';
import { ConfigurationDialogComponent } from './configuration-dialog/configuration-dialog.component';
import { ParameterizationDialogComponent } from './parameterization-dialog/parameterization-dialog.component';
import { MetodologyDialogComponent } from './metodology-dialog/metodology-dialog.component';
import { MacrosDialogComponent } from './macros-dialog/macros-dialog.component';
import { CatalogDialogComponent } from './catalog-dialog/catalog-dialog.component';
import { SubTasksDialogComponent } from './sub-tasks-dialog/sub-tasks-dialog.component';
import { PerfilesComponent } from './perfiles/perfiles.component';
import { PerfilesDialogComponent } from './perfiles-dialog/perfiles-dialog.component';
import { CatalogStatsComponent } from './catalog-stats/catalog-stats.component';
import { MatTableModule } from '@angular/material/table';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatSortModule } from '@angular/material/sort';


@NgModule({
  declarations: [
    BackofficeContainerComponent,
    StepperComponent,
    BackofficeComponent,
    TechnologyComponent,
    TipoProjetoComponent,
    TechDialogComponent,
    RemoveDialogComponent,
    EditNameDialogComponent,
    AddItemBackofficeDialogComponent,
    DocumentationComponent,
    ConfigurationComponent,
    MacroactivityComponent,
    CatalogComponent,
    ProjectRiskComponent,
    UsersComponent,
    SubTasksComponent,
    UserDialogComponent,
    AddTipoProjetoDialogComponent,
    ConfigurationDialogComponent,
    ParameterizationDialogComponent,
    MetodologyDialogComponent,
    MacrosDialogComponent,
    CatalogDialogComponent,
    SubTasksDialogComponent,
    PerfilesComponent,
    PerfilesDialogComponent,
    CatalogStatsComponent
  ],
  imports: [
    CommonModule,
    SharedModule,
    MatStepperModule,
    MatSnackBarModule,
    MatButtonModule,
    FormsModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatRadioModule,
    MatDialogModule,
    MatCheckboxModule,
    MatOptionModule,
    MatSelectModule,
    MatTooltipModule,
    DragDropModule,
    NgxMatSelectSearchModule,
    MatTableModule,
    MatIconModule,
    MatProgressSpinnerModule,
    MatPaginatorModule,
    MatSortModule
  ],
  exports: [
    StepperComponent,
    BackofficeContainerComponent,
    BackofficeComponent,
    PerfilesComponent,
    CatalogStatsComponent
  ],
  providers: [
    {
      provide: STEPPER_GLOBAL_OPTIONS,
      useValue: { displayDefaultIndicatorType: false }
    },
    {
      provide: MAT_SNACK_BAR_DEFAULT_OPTIONS,
      useValue: {
        duration: 2500,
        verticalPosition: 'bottom',
        panelClass: ['error-snackbar']
      }
    }
  ]
})
export class BackofficeModule { }
